import React from "react";
import { PaymentsRoutesResponse } from "src/api";
import AlfredWithdrawalForm from "./AlfredWithdrawalForm";
import TrustPaymentsWithdrawalForm from "./TrustPaymentsWithdrawalForm";
import "./withdrawal-form.scss";

const TRUSTPAYMENTS = "TRUSTPAYMENTS";

// Withdrawal entry point. The widget binds to one payment route per
// session — we render the form matching its `psp_service_id`.
const WithdrawalForm: React.FC<{
  paymentsRoutes: PaymentsRoutesResponse;
}> = ({ paymentsRoutes }): JSX.Element => {
  if (paymentsRoutes.psp_service_id === TRUSTPAYMENTS) {
    return <TrustPaymentsWithdrawalForm route={paymentsRoutes} />;
  }

  return <AlfredWithdrawalForm />;
};

export default WithdrawalForm;
